<template>
<transition name="fade">
  <!--begin::Wrapper-->
  <div
    class="w-lg-500px bg-white rounded shadow-sm p-10 p-lg-15 mx-auto"
    style="background-color: #ffffff !important;"
    v-show="state.displayLogin"
  >
  <div class="w-100 d-flex justify-content-end" v-if="getEnv()">
    <div class="symbol symbol-30px symbol-md-40px me-3">
      <div class="symbol-label fs-2 fw-bold text-primary">Dev</div>
    </div>
  </div>
  <button class="btn btn-danger mx-5 d-none" @click="updateTest()">TEST COOL !!!!!</button>
    <!--begin::Form-->
    <Form
      class="form w-100"
      id="formLogin"
      ref="formLogin"
      @submit="onSubmitLogin"
      :validation-schema="login"
    >
      <!--begin::Heading-->
      <div class="text-center mb-10">
        <img alt="Logo" src="media/logos/stillRH.svg" class="h-150px" />
        <!--end::Title-->
      </div>
      <!--begin::Heading-->
      <!--
      <div class="mb-10 bg-light-info p-8 rounded">
        <div class="text-info">
          Mode Démo, utiliser le login : <strong>demo@demo.com</strong> et le
          mot de passe <strong>alicia</strong> pour continuer.
        </div>
      </div>
      -->
      <!--begin::Input group-->
      <div class="fv-row mb-10">
        <!--begin::Label-->
        <label class="form-label fs-6 fw-bolder text-dark">{{$t("Identifiant")}}</label>
        <!--end::Label-->

        <!--begin::Input-->
        <Field
          class="form-control form-control-lg form-control-solid"
          type="text"
          name="username"
          v-model="state.username"
          autocomplete="off"
        />
        <!--end::Input-->
        <div class="fv-plugins-message-container">
          <div class="fv-help-block">
            <ErrorMessage name="username" />
          </div>
        </div>
      </div>
      <!--end::Input group-->

      <!--begin::Input group-->
      <div class="fv-row mb-10">
        <!--begin::Wrapper-->
        <div class="d-flex flex-stack mb-2">
          <!--begin::Label-->
          <label class="form-label fw-bolder text-dark fs-6 mb-0"
            >{{$t("Mot de passe")}}</label
          >
          <!--end::Label-->

          <!--begin::Link-->
          <router-link to="/password-reset" class="link-primary fs-6 fw-bolder">
            {{$t("Mot de passe oublié ?")}}
          </router-link>
          <!--end::Link-->
        </div>
        <!--end::Wrapper-->

        <!--begin::Input-->
        <Field
          class="form-control form-control-lg form-control-solid"
          type="password"
          name="password"
          autocomplete="off"
          v-model="state.password"
        />
        <!--end::Input-->
        <div class="fv-plugins-message-container">
          <div class="fv-help-block">
            <ErrorMessage name="password" />
          </div>
        </div>
      </div>
      <!--end::Input group-->

      <!--begin::Actions-->
      <div class="text-center">
        <!--begin::Submit button-->
        <button
          type="submit"
          ref="submitButton"
          id="kt_sign_in_submit"
          class="btn btn-lg btn-primary w-100 mb-5"
        >
          <span class="indicator-label"> {{$t("Se connecter")}} </span>

          <span class="indicator-progress">
            {{$t("Chargement...")}}
            <span
              class="spinner-border spinner-border-sm align-middle ms-2"
            ></span>
          </span>
        </button>
        <!--end::Submit button-->
      </div>
      <!--end::Actions-->
    </Form>
    <!--end::Form-->
  </div>
  <!--end::Wrapper-->
</transition>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, reactive } from "vue";
import { ErrorMessage, Field, Form } from "vee-validate";
import { Actions } from "@/store/enums/StoreEnums";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { useI18n } from "vue-i18n";
import * as Yup from "yup";
import mAxiosApi from "@/api";

export default defineComponent({
  name: "sign-in",
  components: {
    Field,
    Form,
    ErrorMessage,
  },
  setup() {
    const store = useStore();
    const router = useRouter();

    const state = reactive({
      username: "",
      password: "",
      displayLogin : false,
    });
    const { t } = useI18n()

    //let username = "";
    //let password = "";

    const submitButton = ref<HTMLElement | null>(null);

    const formLogin = ref<HTMLFormElement | null>(null);

    //Create form validation object
    const login = Yup.object().shape({
      username: Yup.string()
        .email(t("L'identifiant doit être un email valide"))
        .required(t("L'identifiant est obligatoire"))
        .label("username"),
      password: Yup.string()
        .required(t("Le mot de passe est obligatoire"))
        .label("Password"),
    });



    //Form submit function
    const onSubmitLogin = (values) => {
      // Clear existing errors
      store.dispatch(Actions.LOGOUT);

      if (submitButton.value) {
        // Activate indicator
        submitButton.value.setAttribute("data-kt-indicator", "on");
      }

      // Dummy delay
      setTimeout(() => {
        // Send login request
        store
          .dispatch(Actions.LOGIN, values)
          .then(async () => {

            localStorage.setItem("userLogins", JSON.stringify(values))
            if (router.currentRoute.value.params.loginpassword) {
              if (router.currentRoute.value.params.redirect) {
                const stringRec = (router.currentRoute.value.params.redirect) as string;
                if (router.currentRoute.value.params.otherparam) {
                  router.push({ name: stringRec, params: {otherparam: router.currentRoute.value.params.otherparam} });
                } else {
                  router.push({ name: stringRec });
                }
              } else {
                router.push({ name: "profile-overview" });  //stillboard
              }
              return true;
            }
              
            if (router.currentRoute.value.params.redirect) {
              const stringRec = (router.currentRoute.value.params.redirect) as string;             

              if (router.currentRoute.value.params.otherparam) {
                router.push({ name: stringRec, params: {otherparam: router.currentRoute.value.params.otherparam} });
              } else {
                router.push({ name: stringRec });
              }


            } else {
              router.push({ name: "profile-overview" });
            }

            if (window.matchMedia('(display-mode: standalone)').matches) {
              const notifPerm = await Notification.requestPermission()
              if(!("serviceWorker" in navigator) || !("Notification" in window) || notifPerm !== "granted"){
                return;
              }else{
                const registration = await navigator.serviceWorker.register("/sw.js");
                const subscription = await registration.pushManager.getSubscription();  
                await navigator.serviceWorker.ready
                registration.pushManager.subscribe({
                  userVisibleOnly: true,
                  applicationServerKey: process.env.VUE_APP_VAPID_PUBLIC_KEY,
                }).then(async (s)=>{
                  mAxiosApi.post("/setTokenPush", {token: JSON.stringify(s)})
                });
              }
            }

          })
          .catch(() => {
            Swal.fire({
              text: t("Il semble y avoir une erreur, veuillez vérifier vous identifiants de connexion."),
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: t("Retourner sur la page de connexion"),
              customClass: {
                confirmButton: "btn fw-bold btn-light-danger",
              },
            });
          });

        //Deactivate indicator
        submitButton.value?.removeAttribute("data-kt-indicator");
      }, 500);
    };

    const getEnv = () => {
      if (process.env.VUE_APP_ENVIRONNEMENT == "LOCAL" || process.env.VUE_APP_ENVIRONNEMENT == "RECETTE") {
        return "dev";
      }
    }

    onMounted(async () => {
      localStorage.removeItem('storedConst');
      const hasSignInToken = !!router.currentRoute.value.params.loginpassword;
      // #109 : un token de sign-in => toujours forcer logout + login, même si une
      // session est déjà active, pour refléter le collaborateur sélectionné dans l'ERP.
      if (store.getters.isUserAuthenticated && !hasSignInToken){
        if (router.currentRoute.value.params.redirect) {
          const stringRec = (router.currentRoute.value.params.redirect) as string;
          if (router.currentRoute.value.params.otherparam) {
            router.push({ name: stringRec, params: {otherparam: router.currentRoute.value.params.otherparam} });
          } else {
            router.push({ name: stringRec });
          }
          return false;
        }
      }

      state.displayLogin = true;

      if (router.currentRoute.value.params.loginpassword) {
        store.dispatch(Actions.LOGOUT);
        const stringRec = (router.currentRoute.value.params.loginpassword) as string;
        state.username = window.atob(stringRec).split("|$|")[0];
        state.password = window.atob(stringRec).split("|$|")[1];
        
        if (submitButton.value) submitButton.value.click();
      }
      if (localStorage.getItem('publicKey') && localStorage.getItem('userLogins') && /iPhone|iPad|iPod|Android|webOS|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        let challenge = new Uint8Array(64);
        crypto.getRandomValues(challenge);
        challenge =  Uint8Array.from(challenge + '', c => c.charCodeAt(0));
        const publicKeyString = localStorage.getItem('publicKey') as string;
        const publicKeyDecoded = new Uint8Array([...publicKeyString].map(char => char.charCodeAt(0))).buffer;
        const publicKey = {
          challenge: challenge,
          rpId: process.env.VUE_APP_CURRENT_URL,
          allowCredentials: [{
            type: "public-key",
            id: publicKeyDecoded,
            transports: ["usb", "ble", "nfc"],
          }],
          authenticatorSelection: {
            requireResidentKey: true
          },
          timeout: 60000,
        } as any;

        await navigator.credentials.get({ publicKey }) as any;
        onSubmitLogin(JSON.parse(localStorage.getItem("userLogins") as any))
      }
    });   
    
    const updateTest = () => {
      window.location.href = window.location.href.replace(/#.*$/, '?t=' + Math.random());
    }

    return {
      onSubmitLogin,
      login,
      submitButton,
      state,
      formLogin,
      updateTest,
      getEnv
    };
  },
});
</script>
